// S3 Upload Configuration
export const UPLOAD_CONFIG = {
  MAX_FILE_SIZE: 10485760, // 10MB in bytes
  ALLOWED_MIME_TYPES: [
    'image/jpeg',
    'image/jpg', 
    'image/png',
    'image/webp',
    'image/gif'
  ],
  PRESIGN_EXPIRATION: 900, // 15 minutes in seconds
} as const;

// Supported entity types for S3 uploads
export type EntityType = 
  | 'hotel-logo'
  | 'hotel-map'
  | 'restaurant-header'
  | 'facility-header'
  | 'hotelevent-image'
  | 'menuitem-photo'
  | 'roomserviceitem-photo'
  | 'platformuser-avatar';

// Upload validation utilities
export const validateFile = (file: File): { isValid: boolean; error?: string } => {
  if (file.size > UPLOAD_CONFIG.MAX_FILE_SIZE) {
    return {
      isValid: false,
      error: `File size must be less than ${Math.round(UPLOAD_CONFIG.MAX_FILE_SIZE / 1024 / 1024)}MB`
    };
  }

  if (!UPLOAD_CONFIG.ALLOWED_MIME_TYPES.includes(file.type as any)) {
    return {
      isValid: false,
      error: 'File type not supported. Please use JPEG, PNG, WebP, or GIF images.'
    };
  }

  return { isValid: true };
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}; 